import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.289 12.83l.027.027-6.439 6.44c-1.002 1-3.169.818-3.889 1.538-.719.72-2.542-1.105-1.823-1.824.718-.719.386-2.736 1.538-3.888l6.44-6.44c.008.01.017.02.026.028l4.12 4.12zm2.854-2.42l1.914-1.914a3.22 3.22 0 00-4.554-4.553L13.59 5.857a1.421 1.421 0 00-2.008 2.009l4.553 4.553a1.421 1.421 0 002.01-2.009z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
